import React from 'react'
import { inject, observer } from 'src/core/store'
import { Layout } from 'antd'
import Sider from './Sider'
import Header from './Header'
import Footer from './Footer'
import Breadcrumb from './Breadcrumb'
import './main.less'
//
const { Content } = Layout
//
@inject('store')
@observer
export default class extends React.Component {
  componentWillMount() {

  }
  render () {
    return (
      <Layout className='main' style={{minHeight: '100vh'}}>
        <Sider params={this.props.children.props.params} />
        <Layout>
          <Header />
          <Content style={{margin: '0 16px'}}>
            <Breadcrumb params={this.props.children.props.params} />
            <div style={{padding: 24, background: '#fff', minHeight: 360}}>
              <div>
                {this.props.children}
              </div>
            </div>
          </Content>
          <Footer />
        </Layout>
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./layout/main.js